<template>
  <div class="console">
    <div class="topbar">
      <topbar />
    </div>

    <div class="sidebar">
      <sidebar />
    </div>

    <div class="content">
      <router-view />
    </div>

    <div class="footer" />
  </div>
</template>

<style lang="less" scoped>
// topbar的高度
@topbar-height: 60px;
@sidebar-width: 200px;

.console {
  height: 100%;
  position: relative;

  .topbar {
    height: @topbar-height;
  }

  .sidebar {
    width: @sidebar-width;
    float: left;
  }

  .content {
    padding: 10px 15px;
    margin-bottom: 40px;
    margin-left: @sidebar-width;
    overflow: hidden;
  }
}
</style>

<script>
import topbar from './topbar.vue';
import sidebar from './sidebar.vue';

export default {
	components: { sidebar, topbar }
};
</script>
